import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';

import { IconCloseMS, IconDeleteMS } from '../../../../../../constants/icons';
import {
  AlertTypography,
  ButtonBox,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ConfirmationDialogProps {
  text: string;
  modalCallback: () => void;
  iconDelete: boolean;
}

export default function ConfirmationDeleteDialog({
  text,
  modalCallback,
  iconDelete,
}: ConfirmationDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    modalCallback();
    handleClose();
  };

  return (
    <>
      <Tooltip title="Excluir comunicado">
        <IconButton
          sx={{
            color: 'secondary.main',
            height: iconDelete ? '40px' : '34px',
            span: { fontSize: iconDelete ? '24px' : '18px' },
            margin: '0 4px',
          }}
          onClick={handleOpen}
        >
          {iconDelete ? IconDeleteMS : IconCloseMS}
        </IconButton>
      </Tooltip>
      <StyledDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete dialog"
      >
        <DialogContainer>
          <TextTypography>Você gostaria de {text}?</TextTypography>
          <ButtonBox>
            <OutlinedButton onClick={handleClose}>Não</OutlinedButton>
            <FilledButton onClick={handleConfirm}>Sim</FilledButton>
          </ButtonBox>
          <AlertTypography>
            Atenção! Esta ação não poderá ser desfeita.
          </AlertTypography>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
